import SpecializationActionBar from './SpecializationActionBar';

export default SpecializationActionBar;
